import { Heading } from '@chakra-ui/react';
import { MBox, MText, MVStack } from '../../../components/Monetize';

interface QuoteShareCompanyDetailsProps {
  showAccountName: boolean;
  showPo: boolean;
  showVat: boolean;
  accountName?: string | null;
  purchaseOrderNumber?: string | null;
  vatNumber?: string | null;
  isMissingRequiredPo: boolean;
  isMissingRequiredVat: boolean;
}

export const QuoteShareCompanyDetails = ({
  showAccountName,
  showPo,
  showVat,
  accountName,
  purchaseOrderNumber,
  vatNumber,
  isMissingRequiredPo,
  isMissingRequiredVat,
}: QuoteShareCompanyDetailsProps) => {
  return (
    <MBox>
      {showAccountName && (
        <MVStack alignItems="flex-start" gap="0.2rem" mb="0.8rem">
          <Heading as="h3" fontSize="sm" fontWeight="500">
            Legal Name
          </Heading>
          <MText lineClamp={1}>{accountName || 'Blank'}</MText>
        </MVStack>
      )}
      {showVat && (
        <MVStack alignItems="flex-start" gap="0.2rem" mb="0.8rem">
          <Heading as="h3" fontSize="sm" fontWeight="500">
            VAT Number
          </Heading>
          <MText lineClamp={1}>{vatNumber || 'Blank'}</MText>
          {isMissingRequiredVat && (
            <MText color="tOrange.base" fontWeight={500}>
              Please provide a VAT Number to continue.
            </MText>
          )}
        </MVStack>
      )}
      {showPo && (
        <MVStack alignItems="flex-start" gap="0.2rem" mb="0.8rem">
          <Heading as="h3" fontSize="sm" fontWeight="500">
            PO Number
          </Heading>
          <MText lineClamp={1}>{purchaseOrderNumber || 'Blank'}</MText>
          {isMissingRequiredPo && (
            <MText color="tOrange.base" fontWeight={500}>
              Please provide a PO Number to continue.
            </MText>
          )}
        </MVStack>
      )}
    </MBox>
  );
};
